import { useTranslation } from 'react-i18next'
import { makeData } from 'utils/makeData'
import { Container, Tab, Tabs } from 'react-bootstrap'
import { useState } from 'react'
import RankListMobile from './components/RankListMobile'
import ScoreRankListMobile from './components/ScoreRankListMobile'

function RankMobile() {
	const { t } = useTranslation()

	// const rank = makeData('rank', 20)

	const [key, setKey] = useState(t('rankpage.title'))

	return (
		<Container
			style={{ padding: '24px 0 0' }}
			fluid
			className="profilepage-content mobile invitation rank "
		>
			<div style={{ width: '100%' }} className="package-container mobile">
				<Tabs
					id="controlled-tab-example"
					activeKey={key}
					onSelect={k => setKey(k)}
					className="mt-md-0"
				>
					<Tab eventKey={t('rankpage.title')} title={t('rankpage.title')}>
						<RankListMobile />
					</Tab>
					{/* <Tab
						eventKey={t('rankpage.title_t12')}
						title={t('rankpage.title_t12')}
					>
						<ScoreRankListMobile />
					</Tab> */}
				</Tabs>
			</div>
		</Container>
	)
}

export default RankMobile
